import { SvgIcon } from "@material-ui/core";

export const Redo = (props) => (
  <SvgIcon {...props} viewBox="0 0 14 14">
    <path fillRule="evenodd" clipRule="evenodd" d="M10.8687 3.66732H8.33073V5.00065H12.9974V0.333984H11.6641V2.51422C10.514 1.12233 8.86688 0.333984 6.9974 0.333984C3.3155 0.333984 0.330729 3.31875 0.330729 7.00065C0.330729 10.6825 3.3155 13.6673 6.9974 13.6673C10.6793 13.6673 13.6641 10.6825 13.6641 7.00065H12.3307C12.3307 9.94617 9.94291 12.334 6.9974 12.334C4.05188 12.334 1.66406 9.94617 1.66406 7.00065C1.66406 4.05513 4.05188 1.66732 6.9974 1.66732C8.59314 1.66732 9.9617 2.38645 10.8687 3.66732Z" fill="currentColor"/>
  </SvgIcon>
)
